import React from "react";
import { useTranslation } from "react-i18next";
import { SelectPagination } from "@foris/avocado-suite";
import useGetLabelsCategoriesOptions from "@modules/shared/selectors/hooks/useGetLabelsCategoriesOptions";
import { Option } from "react-select/lib/filters";

interface LabelCategorySelectorProps {
  scenario: string;
  value?: Option | null;
  onChange?: (category?: Option | null) => void;
}

const LabelCategorySelector = ({ scenario, value, onChange }: LabelCategorySelectorProps) => {
  const { loadOptions } = useGetLabelsCategoriesOptions({
    scenario,
  });

  const { t } = useTranslation();

  return (
    <SelectPagination
      loadOptions={loadOptions}
      placeholder={t("advanced-search.package.forms.advanced-filters.select-type-tag.placeholder")}
      noOptionsMessage={() => (
        <>{t("advanced-search.package.forms.advanced-filters.select-type-tag.empty-options")}</>
      )}
      onChange={onChange}
      value={value}
    />
  );
};

export default LabelCategorySelector;
